export const getSplitTestCookie = () => {
  const match = document.cookie.match(/(?:^|;\s*)split_test=([^;]*)/)
  return match ? decodeURIComponent(match[1]) : ''
}
